import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./pages/Layout.js";
import HomePage from "./pages/HomePage.js";
import AboutPage from "./pages/AboutPage.js";
import WorkPage from "./pages/WorkPage.js";
import ContactPage from "./pages/ContactPage.js";
import BlogPage from "./pages/BlogPage.js";
import LoadingScreen from "./componets/loadScreen/LoadingScreen.js";
import StairTransition from "./componets/ui/StairTransition.js";
import PostDetail from "./pages/PostDetail.js";
import BlogLayout from "./pages/BlogLayout.js";
import ScrollToTop from "./utils/ScrollTop.js";
import MandlaAssistance from "./componets/agent/MandlaAssistance.js";

function App() {
  const [isLoading, setLoading] = useState(true);
  const [transitionDone, setTransitionDone] = useState(false);

  useEffect(() => {
  const timer = setTimeout(() => setTransitionDone(true), 5500);
  return () => clearTimeout(timer);
}, []);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 4000);
    return () => clearTimeout(timer);
  }, []); // lsitens once

  if (isLoading) return <LoadingScreen />;

  return (
    <BrowserRouter>
      <StairTransition />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="work" element={<WorkPage />} />
          <Route path="contact" element={<ContactPage />} />
        </Route>

        {/* Blog layout*/}
        <Route path="/blog" element={<BlogLayout />}>
          <Route index element={<BlogPage />} />
          <Route path=":id" element={<PostDetail />} />
        </Route>
      </Routes>
      {transitionDone && <MandlaAssistance />}
    </BrowserRouter>
  );
}

export default App;
